<template>
    <div>
        <b-container fluid="xl" class="course">
            <div class="course_title d-flex align-item-center position-sticky py-3">
                <b-link variant="outline-primary" class="back btn btn-outline-primary mr-3 text-nowrap d-flex align-items-center my-auto
                " to="courses" style=" max-height: 50px;"><b-icon-arrow-left-short
                        style="font-size: 155%;"></b-icon-arrow-left-short> 返回列表</b-link>
                <h1 class="title">
                    {{ course.Title }}
                </h1>
            </div>
            <b-row class="mb-4">
                <b-col class="course_detail course-detail-col" cols="12" lg="8">
                    <div class="course-attr border-bottom w-100">
                        <b-row align-v="stretch" class="px-4">
                            <b-col class="px-0 pt-2">
                                <span class="title mx-2 text-nowrap">
                                    <b-icon-house-door-fill class="mr-1"></b-icon-house-door-fill>
                                    上課地點
                                </span>
                                <div class="attr">
                                    <div v-if="course.ClassRoomTitle || course.ClassRoomName">
                                        {{ course.ClassRoomTitle }}
                                        <br />
                                        {{ course.ClassRoomName }}
                                    </div>
                                    <span v-else class="text-muted font-weight-bolder">-</span>
                                </div>
                            </b-col>
                            <b-col class="px-0 pt-2">
                                <span class="title mx-3 text-nowrap">
                                    <b-icon-calendar-week-fill class="mr-1"></b-icon-calendar-week-fill>
                                    上課日期
                                </span>
                                <div class="attr time d-flex flex-column" v-if="course.Start !== ''">
                                    <span class="h5">{{ course.Start | datefmt('YYYY/MM/DD') }}</span>
                                    <span class="h6 mb-1">|</span>
                                    <span class="h5 mb-0">{{ course.End | datefmt('YYYY/MM/DD') }}</span>
                                </div>
                                <div class="attr time" v-else>
                                    無課程時間
                                </div>
                            </b-col>
                            <b-col v-if="course.IsCredit" class="px-0 pt-2">
                                <!-- <b-col  class="px-0"> -->
                                <span class="title mx-4  text-nowrap">
                                    <b-icon-pie-chart-fill class="mr-1"></b-icon-pie-chart-fill>
                                    學分數
                                </span>
                                <div class="attr">
                                    <span>
                                        <span class="number"> {{ course.Credit }} </span>學分
                                        <!-- <span class="number"> 16 </span>學分 -->
                                    </span>
                                </div>
                            </b-col>

                            <b-col class="px-0 pt-2">
                                <span class="title mx-3 text-nowrap">
                                    <b-icon-people-fill class="mr-1"></b-icon-people-fill>
                                    招生名額
                                </span>
                                <div class="attr">
                                    <!-- <span class="mt-3">剩餘</span> -->
                                    <!-- <span class="number mt-auto px-2"> {{ course.Inventory }} </span> -->
                                    <!-- 改成預計招多少人 -->
                                    <span class="number mt-auto px-2"> {{ course.EnrollTarget }} </span>
                                    <span class="mt-3">人</span>
                                </div>
                            </b-col>
                            <b-col class="px-0 pt-2">
                                <span class="title mx-4 text-nowrap">
                                    <b-icon-stopwatch-fill class="mr-1"></b-icon-stopwatch-fill>
                                    上課時數
                                </span>
                                <div class="attr">
                                    <span>
                                        <span class="number">{{ course.TotalHours }} </span>小時
                                    </span>
                                </div>
                            </b-col>
                            <b-col class="px-0 pt-2">
                                <span class="title mx-4 text-nowrap">
                                    <b-icon-clock-fill class="mr-1"></b-icon-clock-fill>
                                    上課時間
                                </span>
                                <div class="attr px-2 h6 lh-lg">
                                    <span>{{ course.TimeMemo }}</span>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                    <div class="bg-white border-bottom p-3 px-4 py-0 my-0" v-if="IsNull(course.Description)">
                        <p class="mb-0">本課程不授予學位證書；欲取得學位應經各類入學考試通過後依規定辦理。</p>
                    </div>
                    <div class="bg-white border-bottom p-3 px-4" v-if="IsNull(course.Description)">
                        <b-button v-b-toggle.courseDescription
                            class="w-100 px-0 bg-white border-0 text-black d-flex align-items-center justify-content-between">
                            <h3 class="title text-left m-0">
                                <span>課程介紹</span>
                            </h3>
                            <b-icon-caret-down-fill variant="dark"></b-icon-caret-down-fill>
                        </b-button>
                        <b-collapse visible id="courseDescription" class="mt-2">
                            <div class="my-3" v-html="IsNull(course.Description)"></div>
                        </b-collapse>
                    </div>
                    <div class="bg-white border-bottom p-3 px-4" v-if="IsNull(course.ClassSchedules)">
                        <b-button v-b-toggle.collapse-ClassSchedules
                            class="w-100 px-0 bg-white border-0 text-black d-flex align-items-center justify-content-between">
                            <h3 class="title text-left m-0">
                                <span>課綱列表</span>
                            </h3>
                            <b-icon-caret-down-fill variant="dark"></b-icon-caret-down-fill>
                        </b-button>

                        <b-collapse visible id="collapse-ClassSchedules" class="mt-2">
                            <b-card class="my-3" v-for="(curriculum, index) in course.ClassSchedules" :key="index">
                                <b-card-text class="d-flex align-items-center justify-content-between flex-wrap">
                                    <div class="h5 d-flex align-items-center justify-content-between mb-0">
                                        <span class="mr-2">{{ curriculum.Start | datefmt('YYYY-MM-DD') }}</span>
                                        <div
                                            class="text-black-50 d-flex align-items-center justify-content-around mb-0">
                                            <span class="">{{ curriculum.Start | datefmt('HH:mm') }}</span> ~
                                            <span>{{ curriculum.End | datefmt('HH:mm') }}</span>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <!-- <span>授課老師：</span> -->
                                        <span class="h6 mb-0">{{ curriculum.TeacherName }}</span>
                                        <span class="ml-2 text-black-50">老師</span>
                                    </div>
                                </b-card-text>
                                <b-card-text v-if="curriculum.Description" v-html="curriculum.Description"
                                    class="border-top mt-2 pt-2"></b-card-text>
                            </b-card>
                        </b-collapse>
                    </div>

                    <div class="bg-white border-bottom p-3 px-4" v-if="course.Suitable">
                        <b-button v-b-toggle="'courseSuitable'"
                            class="w-100 px-0 bg-white border-0 text-black d-flex align-items-center justify-content-between">
                            <h3 class="title m-0">適合對象</h3>
                            <b-icon-caret-down-fill variant="dark" />
                        </b-button>

                        <b-collapse visible id="courseSuitable" class="mt-2">
                            <div class="my-3" v-html="IsNull(course.Suitable)"></div>
                        </b-collapse>
                    </div>

                    <div class="bg-white border-bottom p-3 px-4" v-if="course.Notice">
                        <b-button v-b-toggle="'courseNotice'"
                            class="w-100 px-0 bg-white border-0 text-black d-flex align-items-center justify-content-between">
                            <h3 class="title m-0">報名資格</h3>
                            <b-icon-caret-down-fill variant="dark" />
                        </b-button>

                        <b-collapse visible id="courseNotice" class="mt-2">
                            <div class="my-3" v-html="IsNull(course.Notice)"></div>
                        </b-collapse>
                    </div>
                    <div class="bg-white border-bottom p-3 px-4" v-if="course.Refund">
                        <b-button v-b-toggle="'courseRefund'"
                            class="w-100 px-0 bg-white border-0 text-black d-flex align-items-center justify-content-between">
                            <h3 class="title m-0">退費標準</h3>
                            <b-icon-caret-down-fill variant="dark" />
                        </b-button>

                        <b-collapse visible id="courseRefund" class="mt-2">
                            <div class="my-3" v-html="IsNull(course.Refund)"></div>
                        </b-collapse>
                    </div>
                    <div class="bg-white border-bottom p-3 px-4" v-if="course.RefundOther">
                        <b-button v-b-toggle="'courseRefundOther'"
                            class="w-100 px-0 bg-white border-0 text-black d-flex align-items-center justify-content-between">
                            <h3 class="title m-0">退費其他補充</h3>
                            <b-icon-caret-down-fill variant="dark" />
                        </b-button>

                        <b-collapse visible id="courseRefundOther" class="mt-2">
                            <div class="my-3" v-html="IsNull(course.RefundOther)"></div>
                        </b-collapse>
                    </div>
                    <div class="bg-white border-bottom p-3 px-4" v-if="course.Attend">
                        <b-button v-b-toggle="'courseAttend'"
                            class="w-100 px-0 bg-white border-0 text-black d-flex align-items-center justify-content-between">
                            <h3 class="title m-0">出缺席及注意事項</h3>
                            <b-icon-caret-down-fill variant="dark" />
                        </b-button>

                        <b-collapse visible id="courseAttend" class="mt-2">
                            <div class="my-3" v-html="IsNull(course.Attend)"></div>
                        </b-collapse>
                    </div>
                    <div class="bg-white border-bottom p-3 px-4" v-if="course.Right">
                        <h3 class="title">學員權益</h3>
                        <div v-html="course.Right"></div>
                    </div>
                    <div class="bg-white border-bottom p-3 px-4" v-if="attachments.length > 0">
                        <b-button v-b-toggle="'courseAttachmentsBottom'"
                            class="w-100 px-0 bg-white border-0 text-black d-flex align-items-center justify-content-between">
                            <h3 class="title m-0">課程附件</h3>
                            <b-icon-caret-down-fill variant="dark" />
                        </b-button>

                        <b-collapse visible id="courseAttachmentsBottom" class="mt-2">
                            <div class="course-attachments my-3">
                                <div v-for="attachment in attachments" :key="`bottom-${attachment.fileId}`" class="course-attachment-item">
                                    <div class="course-attachment-content">
                                        <div class="course-attachment-title-row">
                                            <span
                                                :class="['course-attachment-badge', `course-attachment-badge-${getAttachmentTypeKey(attachment)}`]"
                                            >
                                                {{ getAttachmentTypeLabel(attachment) }}
                                            </span>
                                            <b-link class="course-attachment-name"
                                                href="#"
                                                @click.prevent="downloadAttachment(attachment.fileId)">
                                                {{ attachment.name }}
                                            </b-link>
                                        </div>
                                        <p v-if="attachment.description" class="course-attachment-description mb-0">
                                            {{ attachment.description }}
                                        </p>
                                    </div>
                                    <b-link class="course-attachment-download text-nowrap"
                                        href="#"
                                        @click.prevent="downloadAttachment(attachment.fileId)">
                                        下載
                                    </b-link>
                                </div>
                            </div>
                        </b-collapse>
                    </div>
                </b-col>
                <b-col class="external-signin-col mb-3" cols="12" lg="4">
                    <div class="external-signin w-100">
                        <div class="signup shadow-sm">
                            <figure v-if="course.Cover != ''" class="bg-blur mb-0 ratio-1440x452"
                                style="background-size: cover; background-position: center;" :style="{
                                    '--bg-url': 'url(' + $store.state.FilePath + 'files' + course.Cover + ')',
                                }">
                                <b-img :src="IsNull($store.state.FilePath + 'files' + course.Cover)"
                                    style="object-fit: contain; object-position: center;"
                                    class="shadow-sm rounded-lg ratio-1440x452 d-block w-100"></b-img>
                                <div v-if="isApplyNow(course)" class="course-badge course-cover-badge">報名中</div>
                            </figure>

                            <b-img v-else src="./asset/no-image.png" fluid
                                style="object-fit: cover; object-position: center;"
                                class="shadow-sm rounded-lg ratio-1440x452 d-block w-100"></b-img>
                            <div class="signup-body">
                                <div class="course-signup-term pb-1 mb-2">
                                    <div class="state2 d-flex flex-wrap align-items-center w-100"
                                        style="max-width: 100%;">
                                        <b-badge v-for="(item, index) in course.Tags" :key="index">{{ item }}</b-badge>
                                    </div>
                                    <p class="text-black-50 mb-1">
                                        <!-- <b-icon-calendar2-week-fill class="mr-1"></b-icon-calendar2-week-fill> -->
                                        報名日期
                                    </p>
                                    <p
                                        class="h5 font-weight-bold text-primary d-flex align-items-center justify-content-between">
                                        <span class="">{{ course.ApplyStart | datefmt('YYYY/MM/DD') }}</span>
                                        <span class="text-black-50">~</span>
                                        <span>{{ course.ApplyEnd | datefmt('YYYY/MM/DD') }}</span>
                                    </p>
                                </div>

                                <ul class="list-unstyled mb-0">
                                    <li class="d-flex align-items-center justify-content-between">
                                        <span class="fw-bolder text-black-50">
                                            <!-- <b-icon-handbag-fill class="mr-1"></b-icon-handbag-fill> -->
                                            課程費用
                                        </span>
                                        <span class="price pb-2">
                                            NT$<span class="number">{{ course.OrginalPrice | money(0, 2) }}</span>
                                        </span>
                                    </li>
                                    <li class="d-flex align-items-center justify-content-between">
                                        <span class="text-black-50">
                                            <!-- <b-icon-gift-fill class="mr-1"></b-icon-gift-fill> -->
                                            <span v-if="course.EarlyBird">早鳥</span>
                                            優惠價</span>
                                        <span class="price pb-2">
                                            NT$<span class="number">{{ course.Price | money(0, 2) }}</span></span>
                                    </li>
                                </ul>
                                <div v-if="canApply">
                                    <b-button variant="primary" class="px-5" size="lg" block :disabled="loading"
                                        @click="SignUp">我要報名</b-button>
                                </div>

                                <b-alert :show="!canApply && course.IsOnline" variant="secondary" class="text-center"
                                    style="font-weight:bold;">
                                    規劃中
                                </b-alert>
                                <b-button
                                    variant="outline-danger"
                                    block
                                    class="mt-3 favorite-course-button"
                                    :disabled="isFavoritePending(course)"
                                    @click="toggleFavorite(course)"
                                >
                                    <b-icon-heart-fill v-if="isFavorite(course)" class="mr-2"></b-icon-heart-fill>
                                    <b-icon-heart v-else class="mr-2"></b-icon-heart>
                                    <span class="favorite-course-label">
                                        {{ isFavorite(course) ? '從喜好清單移除' : '我有興趣' }}
                                    </span>
                                    我有興趣
                                </b-button>
                            </div>
                        </div>
                        <div class="bg-white p-3 px-4 mt-4 shadow-sm" v-if="IsNull(course.PreviewContent)">
                            <b-button v-b-toggle="'coursePreviewContent'"
                                class="w-100 px-0 bg-white border-0 text-black d-flex align-items-center justify-content-between">
                                <div style="
                                    display: inline-flex;
                                    align-items: center;
                                    gap: 8px;
                                    background: linear-gradient(135deg, #b68b3c, #8c6a2d);
                                    color: #fff;
                                    font-size: 16px;
                                    font-weight: 600;
                                    letter-spacing: 1px;
                                    padding: 7px 14px 11px;
                                    border-radius: 999px;
                                    box-shadow: 0 4px 12px rgba(182, 139, 60, 0.25);
                                ">
                                    ✦ 下期預告
                                </div>
                                <b-icon-caret-down-fill style="color: #8c6a2d; font-size: 1.1rem;" />
                            </b-button>
                            <b-collapse visible id="coursePreviewContent" class="mt-2">
                                <div class="my-3" v-html="IsNull(course.PreviewContent)"></div>
                            </b-collapse>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import {
    apiCheckMember,
    apiAddCart,
    apiGetCourse,
    apiGetCourseAttachments,
    apiDownloadCourseAttachment,
} from '@/api/API.js';
import courseFavorite from '@/mixins/courseFavorite.js';
import moment from 'moment';

export default {
    name: 'Course',
    mixins: [courseFavorite],

    data() {
        return {
            Id: '',
            course: {},
            attachments: [],
            loading: false,
        };
    },

    computed: {
        canApply() {
            const c = this.course || {};
            if (!c.IsOpen) return false;
            if (!c.ApplyStart || !c.ApplyEnd) return false;
            if (Number(c.Inventory) <= 0) return false;

            const now = moment();
            const start = moment(c.ApplyStart);
            const end = moment(c.ApplyEnd).endOf('day'); // 含整個結束日
            if (!start.isValid() || !end.isValid()) return false;

            return now.isBetween(start, end, undefined, '[]'); // 含頭尾
        },
    },

    mounted() {
        // this.modal_init(this.modal_set);
        // let navBgSwitch = this._storeData('navBgSwitch');
        // if (this.IsNull(navBgSwitch) != '') {
        //     navBgSwitch(false);
        // }
        // this.sessionF1();
        this.Init();
        this.loadFavoriteProducts();
    },
    methods: {
        AddCart() {
            apiAddCart(this.course.ProductId, {})
                .then((res) => {
                    console.log(res);
                    alert('成功加入購物車');
                    this.$store.dispatch('courseCart/fetchCount');
                })
                .catch((err) => {
                    //alert(err.response.data);
                    console.log(err);
                });
        },
        Init() {
            this.Id = this.$route.query.Id;
            this.attachments = [];
            apiGetCourse(this.Id)
                .then((res) => {
                    this.course = res.data;
                    this.CheckDate(this.course);
                    this.loadAttachments();
                })
                .catch((err) => {
                    console.log(err);
                    // alert('查無此課程');
                    // this.$router.push('/');
                });
        },
        CheckDate(data) {
            var Now = moment();
            return Now.isBetween(data.ApplyStart, data.ApplyEnd, null, '[]');
        },

        loadAttachments() {
            if (this.IsNull(this.Id) === '') {
                this.attachments = [];
                return;
            }

            apiGetCourseAttachments(this.Id)
                .then((res) => {
                    this.attachments = this.normalizeAttachmentsResponse(res.data);
                })
                .catch((err) => {
                    console.log(err);
                    this.attachments = [];
                });
        },
        normalizeAttachmentsResponse(payload) {
            const rawItems = Array.isArray(payload)
                ? payload
                : Array.isArray(payload && payload.data)
                    ? payload.data
                    : Array.isArray(payload && payload.Data)
                        ? payload.Data
                        : [];

            return rawItems
                .map((item, index) => this.normalizeAttachmentItem(item, index))
                .filter((item) => item !== null)
                .sort((a, b) => a.sort - b.sort);
        },
        normalizeAttachmentItem(item, index) {
            if (!item || typeof item !== 'object') return null;

            const fileId = this.pickFirstValue(item, ['fileId', 'FileId', 'fileID', 'FileID', 'id', 'Id', 'AF_ID']);
            const name = this.pickFirstValue(item, [
                'name',
                'Name',
                'attachmentName',
                'AttachmentName',
                'displayName',
                'DisplayName',
                'title',
                'Title',
                'fileName',
                'FileName',
                'originalFileName',
                'OriginalFileName',
            ]);
            const description = this.pickFirstValue(
                item,
                ['description', 'Description', 'summary', 'Summary', 'memo', 'Memo', 'note', 'Note'],
                '',
            );
            const isEnabled = this.pickFirstValue(
                item,
                ['isEnabled', 'IsEnabled', 'isEnable', 'IsEnable', 'isOpen', 'IsOpen', 'isActive', 'IsActive', 'enabled', 'Enabled'],
                true,
            );
            const sort = this.pickFirstValue(item, ['sort', 'Sort', 'sortOrder', 'SortOrder', 'order', 'Order'], index);

            if (this.IsNull(fileId) === '' || this.IsNull(name) === '') return null;
            if (!this.toBoolean(isEnabled)) return null;

            return {
                fileId,
                name,
                description: this.IsNull(description),
                extension: this.resolveAttachmentExtension(item, name),
                sort: Number.isFinite(Number(sort)) ? Number(sort) : index,
            };
        },
        resolveAttachmentExtension(item, name) {
            const explicitExtension = this.pickFirstValue(item, [
                'extension',
                'Extension',
                'ext',
                'Ext',
                'fileExtension',
                'FileExtension',
                'contentTypeExtension',
                'ContentTypeExtension',
            ]);

            const normalizedExplicitExtension = this.normalizeAttachmentExtension(explicitExtension);
            if (normalizedExplicitExtension !== '') return normalizedExplicitExtension;

            const normalizedName = this.IsNull(name);
            const matchedExtension = normalizedName.match(/\.([a-z0-9]+)$/i);
            return matchedExtension && matchedExtension[1]
                ? matchedExtension[1].toLowerCase()
                : '';
        },
        normalizeAttachmentExtension(extension) {
            const normalizedExtension = this.IsNull(extension).toString().trim().replace(/^\./, '').toLowerCase();
            return normalizedExtension;
        },
        pickFirstValue(source, keys, fallback = '') {
            for (let i = 0; i < keys.length; i++) {
                const value = source[keys[i]];
                if (value !== undefined && value !== null && value !== '') {
                    return value;
                }
            }

            return fallback;
        },
        toBoolean(value) {
            if (typeof value === 'boolean') return value;
            if (typeof value === 'number') return value !== 0;
            if (typeof value === 'string') {
                const normalized = value.trim().toLowerCase();
                if (['false', '0', 'n', 'no'].includes(normalized)) return false;
                if (['true', '1', 'y', 'yes'].includes(normalized)) return true;
            }

            return Boolean(value);
        },
        getDownloadFileName(res, fallback = 'attachment') {
            const disposition = res && res.headers ? (res.headers['content-disposition'] || res.headers['Content-Disposition'] || '') : '';
            const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
            if (utf8Match && utf8Match[1]) {
                try {
                    return decodeURIComponent(utf8Match[1]);
                } catch (err) {
                    return utf8Match[1];
                }
            }

            const fileNameMatch = disposition.match(/filename="?([^";]+)"?/i);
            if (fileNameMatch && fileNameMatch[1]) {
                return fileNameMatch[1];
            }

            return fallback;
        },
        getAttachmentTypeKey(attachment) {
            const extension = this.normalizeAttachmentExtension(attachment && attachment.extension);
            if (['jpg', 'jpeg'].includes(extension)) return 'jpg';
            if (extension === 'png') return 'png';
            if (extension === 'pdf') return 'pdf';
            if (['doc', 'docx'].includes(extension)) return 'docx';
            return 'default';
        },
        getAttachmentTypeLabel(attachment) {
            const extension = this.normalizeAttachmentExtension(attachment && attachment.extension);
            if (extension === 'jpeg') return 'JPG';
            if (extension === 'doc') return 'DOCX';
            if (extension !== '') return extension.toUpperCase();
            return 'FILE';
        },
        downloadAttachment(fileId) {
            apiDownloadCourseAttachment(fileId)
                .then((res) => {
                    const fallbackName = `attachment-${fileId}`;
                    const fileName = this.getDownloadFileName(res, fallbackName);
                    const blobUrl = window.URL.createObjectURL(res.data);
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(blobUrl);
                })
                .catch((err) => {
                    console.log(err);
                });
        },

        SignUp() {
            apiCheckMember()
                .then(() => {
                    this.AddCart();
                })
                .catch((err) => {
                    this._storeData('LoginFUN', (path2) => {
                        if (this.$route.path == path2) {
                            this.SignUp();
                        }
                    });
                    const openLogin = this._storeData('LoginF1');
                    if (this.IsNull(openLogin) != '') {
                        openLogin();
                    } else {
                        this.$root.$emit('bv::show::modal', 'signin');
                        if (typeof this.FunctionGetImageCode === 'function') {
                            this.FunctionGetImageCode();
                        }
                    }
                    console.log(err);
                });
        },
        isApplyNow(item) {
            if (!item) return false;
            const start = item.ApplyStart ? new Date(item.ApplyStart) : null;
            const end = item.ApplyEnd ? new Date(item.ApplyEnd) : null;
            if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) return false;
            const now = new Date();
            // include whole end day if time part missing
            const endAt = new Date(end.getTime());
            if (endAt.getHours() === 0 && endAt.getMinutes() === 0 && endAt.getSeconds() === 0) {
                endAt.setHours(23, 59, 59, 999);
            }
            return now >= start && now <= endAt;
        },
    },
};
</script>

<style scoped>
::v-deep .course-contact-card {
    --brand: #1f5f96;
    --brand-light: #edf5fc;
    --text: #2f3338;
    --muted: #707780;
    --border: #d9e3ec;
    --bg: #f4f6f8;
    --white: #fff;
    position: relative;
    margin-top: 30px;
    padding: 24px 26px 25px;
    overflow: hidden;
    border: 1px solid var(--border, #d9e2ea);
    border-left: 5px solid var(--brand, #1f5f96);
    border-radius: 10px;
    background: linear-gradient(135deg, #fbfdff 0%, #f5f9fd 100%);
}

::v-deep .course-contact-card::after {
    content: '';
    position: absolute;
    top: -45px;
    right: -45px;
    width: 130px;
    height: 130px;
    border-radius: 50%;
    background: rgba(31, 95, 150, 0.055);
}

::v-deep .contact-heading {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
}

::v-deep .contact-heading__icon {
    display: grid;
    place-items: center;
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    border-radius: 50%;
    background: var(--brand-light, #e8f1f8);
    color: var(--brand, #1f5f96);
}

::v-deep .contact-heading__icon svg {
    width: 22px;
    height: 22px;
}

::v-deep .contact-heading h3 {
    margin: 0;
    font-size: 20px;
    line-height: 1.3;
    color: #244c70;
}

::v-deep .contact-desc {
    position: relative;
    z-index: 1;
    margin: 0 0 20px 54px !important;
    color: var(--muted, #6c757d) !important;
    font-size: 15px;
}

::v-deep .contact-grid {
    position: relative;
    z-index: 1;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px 18px;
    padding-top: 18px;
    border-top: 1px solid rgba(31, 95, 150, 0.15);
}

::v-deep .contact-item {
    display: flex;
    min-width: 0;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.72);
}

::v-deep .contact-item__icon {
    display: grid;
    place-items: center;
    width: 34px;
    height: 34px;
    flex: 0 0 34px;
    margin-top: 1px;
    border-radius: 8px;
    background: var(--brand-light, #e8f1f8);
    color: var(--brand, #1f5f96);
}

::v-deep .contact-item__icon svg {
    width: 17px;
    height: 17px;
}

::v-deep .contact-item__body {
    min-width: 0;
}

::v-deep .contact-item__label {
    margin-bottom: 1px;
    color: #7b838c;
    font-size: 13px;
    line-height: 1.4;
}

::v-deep .contact-item__value {
    color: #30363c;
    font-size: 16px;
    font-weight: 600;
    overflow-wrap: anywhere;
}

::v-deep .contact-item__value a {
    color: var(--brand, #1f5f96);
    text-decoration: none;
}

::v-deep .contact-item__value a:hover {
    text-decoration: underline;
}

.course-attachments {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.course-attachment-item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    padding: 0.875rem 1rem;
    border: 1px solid #e9ecef;
    border-radius: 0.5rem;
    background: #fff;
}

.course-attachment-content {
    min-width: 0;
}

.course-attachment-title-row {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-wrap: wrap;
}

.course-attachment-badge {
    width: 56px;
    text-align: center;
    font-size: 12px;
    font-weight: bolder;
    padding: 6px 0;
    border-radius: 999px;
    white-space: nowrap;
    flex: 0 0 auto;
}

.course-attachment-badge-jpg {
    background: #e0f2fe;
    color: #0369a1;
}

.course-attachment-badge-png {
    background: #dcfce7;
    color: #15803d;
}

.course-attachment-badge-pdf {
    background: #fee2e2;
    color: #b91c1c;
}

.course-attachment-badge-docx {
    background: #dbeafe;
    color: #1d4ed8;
}

.course-attachment-badge-default {
    background: #e5e7eb;
    color: #374151;
}

.course-attachment-name {
    display: inline-block;
    color: #212529;
    font-weight: 600;
    word-break: break-word;
}

.course-attachment-name:hover,
.course-attachment-name:focus {
    color: #0056b3;
    /* text-decoration: underline; */
}

.course-attachment-description {
    margin-top: 0.375rem;
    color: #6c757d;
    white-space: pre-line;
    word-break: break-word;
}

.course-attachment-download {
    color: #0056b3;
    font-weight: bolder !important;
    font-size: 14px;
    text-decoration: none;
}

@media (max-width: 575.98px) {
    .course-attachment-item {
        flex-direction: column;
    }
}

@media (max-width: 720px) {
    ::v-deep .course-contact-card {
        padding: 20px 18px 22px;
    }

    ::v-deep .contact-desc {
        margin-left: 0 !important;
        margin-top: 12px !important;
    }

    ::v-deep .contact-grid {
        grid-template-columns: 1fr;
    }
}

.course-cover-badge {
    /* position: absolute; */
    /* left: 0.75rem;
    bottom: 0.75rem; */
    z-index: 2;
}

.favorite-course-button {
    font-weight: 700;
    font-size: 0;
    color: transparent;
}

.favorite-course-button .b-icon {
    font-size: 1rem;
    color: #dc3545;
}

.favorite-course-label {
    font-size: 1rem;
    color: #dc3545;
}

.favorite-course-button:hover .b-icon,
.favorite-course-button:focus .b-icon,
.favorite-course-button:hover .favorite-course-label,
.favorite-course-button:focus .favorite-course-label {
    color: #fff;
}
</style>

